import { useCallback, useEffect, useState } from 'react'
import { getLang } from '../globals'
import { dictionaryTwoLevelFromJsonArr } from '../globals/dictionary'

export interface LangDataProps {
    myData: any
    fieldsToLang: string[]
    keyValue: string
}
export interface DataProps {
    [field: string]: any
}

const useLangData = ({ myData, fieldsToLang, keyValue }: LangDataProps) => {
    const [data, setData] = useState<DataProps | null>(null)
    const [selectedLang, setSelectedLang] = useState<string>(getLang())
    const fieldsStringlified = JSON.stringify(fieldsToLang)
    const changeData = useCallback((dataToParse: any) => {
        const fieldsParsed = JSON.parse(fieldsStringlified)
        const parsedResult = dictionaryTwoLevelFromJsonArr(dataToParse, fieldsParsed, keyValue)
        setData(parsedResult)
    }, [fieldsStringlified, keyValue])

    const changeLang = useCallback((lang: string) => {
        setSelectedLang(lang)
    }, [setSelectedLang])

    const changeValCurrentLang = useCallback((field: string, value: string) => {
        setData((old) => {
            if (old) {
                old[field] = { ...old[field], [selectedLang]: value }
                return { ...old }
            } else {
                return { [field] : { [selectedLang]: value } }
            }
        })
    }, [selectedLang, setData])

    useEffect(() => {
        if (!data && myData) {
            changeData(myData)
        }
    }, [changeData, data, myData, fieldsToLang])
    return { changeLang, selectedLang, data, changeValCurrentLang, changeData}
}

export default useLangData
